import { Property } from 'csstype';
import styled, { css } from 'styled-components';

import { Button } from '../button/Button';
import { customScrollMinimal } from '../custom-scroll/CustomScroll.styles';

export const DRAWER_WIDTH = 600;

interface DrawerStyledProps {
  $isOpen: boolean;
  $width?: Property.Width;
}

export const RootContainer = styled.div``;

export const BackgroundOverlay = styled.div<DrawerStyledProps>`
  content: '';
  z-index: var(--z-index-modal);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--background-backdrop);
  transition: opacity 0.3s ease-out;

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          opacity: 0.7;
          top: 0;
        `
      : css`
          opacity: 0;
        `}
`;

export const Container = styled.section<DrawerStyledProps>`
  width: ${DRAWER_WIDTH}px;
  height: 100%;
  max-height: 100vh;
  display: flex;
  position: fixed;
  right: 0;
  flex-direction: column;
  top: 0;
  z-index: var(--z-index-modal);
  background-color: var(--background-soft);
  transition: transform 0.3s ease-out;
  ${({ $isOpen }) =>
    $isOpen
      ? css`
          transform: translateX(0%);
        `
      : css`
          transform: translateX(100%);
        `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  padding: 4px 4px 4px 12px;
`;

export const Body = styled.div`
  ${customScrollMinimal};
  flex: 1;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  scroll-behavior: smooth;
`;

export const StyledButton = styled(Button)`
  && {
    padding: 2px 7px;
    height: 32px;
  }
`;
